var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cp-progress-main"},[_c('div',{staticClass:"cp-progress-bg",style:({ 'border-radius': _vm.bRadius + 'px' })},[_c('div',{staticClass:"cp-progress-bg1"}),(_vm.getPercentage != 0)?_c('div',{staticClass:"cp-progress-bar",style:({
        width: _vm.getPercentage + '%',
        height: _vm.strokeWidth + 'px',
        'border-radius': _vm.bRadius + 'px',
      })},[_c('div',{staticClass:"cp-progress-text",style:({ 'line-height': _vm.strokeWidth + 16 + 'px' })},[_vm._v(" "+_vm._s(_vm.getPercentage)+"% ")])]):_vm._e(),(_vm.getPercentage != 0)?_c('div',{staticClass:"cp-progress-bar2"}):_vm._e(),(_vm.getPercentage1 != 0)?_c('div',{staticClass:"cp-progress-bar1",style:({
        width: _vm.getPercentage1 + '%',
        height: _vm.strokeWidth + 'px',
        'border-radius': _vm.bRadius + 'px',
        'margin-left': _vm.percentage == 0 ? '0' : '-10px',
      })},[_c('div',{staticClass:"cp-progress-text1",style:({ 'line-height': _vm.strokeWidth + 16 + 'px' })},[_vm._v(" "+_vm._s(_vm.getPercentage1)+"% ")])]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }